import { useState } from 'react';
import type { CaseId } from '@casetrace/shared';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { ConversationList } from './conversation-list';
import { IphoneSmsGuide } from './iphone-sms-guide';
import { useIphoneSmsImport } from './use-iphone-sms-import';
import { SourceTypeIcon } from '../source-type-icon';

function errorMessage(error: unknown): string | undefined {
  return error instanceof Error ? error.message : undefined;
}

export function IphoneSmsImportSection({ caseId }: { readonly caseId: CaseId }) {
  const [open, setOpen] = useState(false);
  const { conversations, uploadMutation, importMutation, reset } = useIphoneSmsImport(caseId);

  const hasPreview = conversations.length > 0;

  const handleClose = () => {
    setOpen(false);
    reset();
  };

  return (
    <div className="mt-2">
      <Button variant="outline" className="w-full" onClick={() => setOpen((prev) => !prev)}>
        <SourceTypeIcon type="iphone_backup" />
        Importer SMS/iMessage fra iPhone-backup
        {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
      </Button>

      {open && (
        <div className="mt-2 flex flex-col gap-3 rounded-md border border-white/[0.08] p-3">
          {!hasPreview ? (
            <IphoneSmsGuide
              onFileSelected={(file) => uploadMutation.mutate(file)}
              isPending={uploadMutation.isPending}
              errorMessage={errorMessage(uploadMutation.error)}
            />
          ) : (
            <>
              <ConversationList
                conversations={conversations}
                totalMessages={uploadMutation.data?.totalMessages}
                onImport={(selection) => importMutation.mutate(selection)}
                isImporting={importMutation.isPending}
                importError={errorMessage(importMutation.error)}
                hasStarted={importMutation.isSuccess}
              />
              <button
                type="button"
                className="text-xs text-[#8b8d9a] hover:text-[#ededf0]"
                onClick={handleClose}
              >
                Last opp en annen fil
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
